"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const trans_1 = require("@common/tsutils/trans");
const Dashboard_1 = __importDefault(require("../models/Dashboard"));
const DashboardService_1 = __importDefault(require("../services/DashboardService"));
class DashboardController {
    constructor() {
        this.data = new Dashboard_1.default();
        this.service = new DashboardService_1.default();
        this.filter = (0, trans_1.trans)('dashboard_single.list.all');
        this.lastProjects = [];
        this.lastSamples = [];
    }
    async init(url = '') {
        this.service = new DashboardService_1.default(url);
        await this.service.call();
        if (this.service.data.projects.length < 1)
            this.filter = 'All Crops';
        this.sortByDate();
        this.sortByDateSamples();
        this.filterProjectsByType();
        this.filterSamplesByType();
    }
    get getData() {
        return this.service.data;
    }
    get getFarmData() {
        return this.service.farmData;
    }
    get isLoading() {
        return this.service.isLoading;
    }
    capitalize(inputString) {
        return inputString.charAt(0).toUpperCase() + inputString.slice(1);
    }
    get projectsTypes() {
        const types = new Set();
        types.add((0, trans_1.trans)('dashboard_single.list.all'));
        this.service.data.projects.forEach((project) => {
            types.add(`${(0, trans_1.trans)('dashboard_single.project_filter')} ${this.capitalize(project.type)}`);
        });
        return Array.from(types);
    }
    get samplesCrops() {
        const types = new Set();
        types.add('All Crops');
        this.service.data.samples.forEach((sample) => {
            types.add(this.capitalize(sample.crop.name));
        });
        return Array.from(types);
    }
    sortByDate() {
        this.service.data.projects.sort((a, b) => {
            const dateA = new Date(a.date).getTime();
            const dateB = new Date(b.date).getTime();
            return dateB - dateA;
        });
    }
    sortByDateSamples() {
        this.service.data.samples.sort((a, b) => {
            const dateA = new Date(a.date).getTime();
            const dateB = new Date(b.date).getTime();
            return dateB - dateA;
        });
    }
    filterProjectsByType() {
        if (this.filter === (0, trans_1.trans)('dashboard_single.list.all')) {
            this.lastProjects = this.service.data.projects.slice(0, 5);
        }
        else {
            this.lastProjects = this.service.data.projects
                .filter((project) => {
                return ((0, trans_1.trans)('dashboard_single.project_filter') +
                    ' ' +
                    this.capitalize(project.type) ===
                    this.filter);
            })
                .slice(0, 5);
        }
    }
    filterSamplesByType() {
        if (this.filter === 'All Crops') {
            this.lastSamples = this.service.data.samples.slice(0, 5);
        }
        else {
            this.lastSamples = this.service.data.samples
                .filter((sample) => {
                return this.capitalize(sample.crop.name) === this.filter;
            })
                .slice(0, 5);
        }
    }
    updateFilter(newFilter) {
        this.filter = newFilter;
        this.filterProjectsByType();
        this.filterSamplesByType();
    }
}
exports.default = DashboardController;
